import React from 'react'

function Faq() {
    const page = "faq";
  return (
    <div>
        <section className={`hero ${page}`}>
            <h1>Frequently Asked Questions (FAQ)</h1>
        </section>        

        <section class="faq">
        <div class="faq__wrap">
            <details class="faq__item" open>
            <summary>What does your company manufacture?</summary>
            <div class="faq__content">
                <p>
                    We specialize in producing high-quality <strong>drilling materials</strong> used in oil, gas, and 
                    industrial applications. Our product range is designed to meet stringent quality 
                    standards for performance, safety, and sustainability.
                </p>
            </div>
            </details>

            <details class="faq__item">
            <summary>Who are your typical clients?</summary>
            <div class="faq__content">
                <p>
                    Our clients include oil & gas companies, drilling contractors, service providers, 
                    and industrial operators who require reliable and certified drilling materials.
                </p>
            </div>
            </details>

            <details class="faq__item">
            <summary>you supply internationally?</summary>
            <div class="faq__content">
                <p>
                    Yes. We supply both <strong>domestic and international markets</strong>. Logistics and export 
                    documentation support can be provided for global clients.
                </p>
            </div>
            </details>

            <details class="faq__item">
            <summary>How do you ensure product quality?</summary>
            <div class="faq__content">
                <p>
                    All materials undergo <strong>strict internal quality control procedures</strong>, pilot testing, 
                    and supplier facility audits. We comply with international standards such as 
                    <strong> ISO 9001, ISO 14001, and ISO 45001</strong>, ensuring consistency and safety.
                </p>
            </div>
            </details>
            <details class="faq__item">
            <summary>Can you develop custom materials or formulations?</summary>
            <div class="faq__content">
                <p>
                    Yes. Our R&D and technical teams work closely with clients to develop <strong>tailor-made 
                    drilling materials</strong> to meet specific operational requirements.
                </p>
            </div>
            </details>
            <details class="faq__item">
            <summary>What certifications do you hold?</summary>
            <div class="faq__content">
                <p>
                    We adhere to internationally recognized standards, including <strong>ISO certifications</strong> and 
                    <strong> HSE compliance</strong>, ensuring our processes and products meet global benchmarks.
                </p>
            </div>
            </details>
            <details class="faq__item">
            <summary>How can I request product data sheets or MSDS?</summary>
            <div class="faq__content">
                <p>
                    Product Data Sheets (PDS) and Material Safety Data Sheets (MSDS) are available upon 
                    request. Please contact our <strong>technical support team</strong> via the Contact Us page.
                </p>
            </div>
            </details>
            <details class="faq__item">
            <summary>How can I become an approved supplier?</summary>
            <div class="faq__content">
                <p>
                    Suppliers undergo a <strong>rigorous onboarding process</strong> that includes audits, ESG compliance 
                    checks, and pilot trials. Qualified vendors are added to our 
                    <strong> Approved Vendor List (AVL)</strong>.
                </p>
            </div>
            </details>
            <details class="faq__item">
            <summary>What support do you provide after delivery?</summary>
            <div class="faq__content">
                <p>
                    We offer <strong>technical assistance, product performance monitoring, and continuous 
                    improvement feedback loops</strong> to ensure drilling efficiency and client satisfaction.
                </p>
            </div>
            </details>
            <details class="faq__item">
            <summary>How can I get in touch with your team?</summary>
            <div class="faq__content">
                <p>
                    You can contact us through the <strong>Contact Us</strong> section on our website, or email us at  
                     <strong> info@mawad-drilling.com</strong>. Our sales and technical teams will be happy to assist you.
                </p>
            </div>
            </details>                                                                        
        </div>
        </section>
        
    </div>
  )
}

export default Faq